const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    } catch {
        return dateString;
    }
};

const StudentSection = ({ studentData }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 print:mb-6">
            <div className="col-span-2">
                <div className="space-y-4 print:space-y-3">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 print:gap-3">
                        <div>
                            <p className="text-sm text-[#0d4f5c] font-medium">Student Name</p>
                            <p className="font-bold text-lg">{studentData.name || 'N/A'}</p>
                        </div>
                        <div>
                            <p className="text-sm text-[#0d4f5c] font-medium">Roll Number</p>
                            <p className="font-bold text-lg">{studentData.rollNumber || 'N/A'}</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 print:gap-3">
                        <div>
                            <p className="text-sm text-[#0d4f5c] font-medium">Date of Birth</p>
                            <p className="font-medium">{studentData.dateOfBirth ? formatDate(studentData.dateOfBirth) : 'N/A'}</p>
                        </div>
                        <div>
                            <p className="text-sm text-[#0d4f5c] font-medium">Program</p>
                            <p className="font-medium">{studentData.programName || 'N/A'}</p>
                        </div>
                    </div>
                    <div>
                        <p className="text-sm text-[#0d4f5c] font-medium">Semester</p>
                        <p className="font-medium">{studentData.semester ? `${studentData.semester} Semester` : 'N/A'}</p>
                    </div>
                </div>
            </div>

            <div className="flex flex-col items-center print:space-y-4">
                <div className="w-32 h-32 mb-4 bg-gray-100 rounded-lg overflow-hidden border border-[#0d4f5c]">
                    {studentData.photo ? (
                        <img src={studentData.photo} alt="Student" className="w-full p-1 h-full object-cover" />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center text-gray-400">No Photo</div>
                    )}
                </div>
                <div className="w-32 h-16 mb-1 bg-gray-50 border border-[#0d4f5c] rounded-md overflow-hidden flex items-center justify-center">
                    {studentData?.signatureUrl ? (
                        <img src={studentData.signatureUrl} alt="Student Signature" className="w-full h-full object-contain p-1" loading="lazy" />
                    ) : (
                        <span className="text-xs text-gray-400 font-medium">No Signature</span>
                    )}
                </div>
                <div className="text-center">
                    <p className="text-sm text-[#0d4f5c] font-medium">Principal's Signature</p>
                    <div className="w-40 h-0.5 bg-[#0d4f5c] mx-auto my-1"></div>
                    <p className="text-xs text-gray-500">(College Seal)</p>
                </div>
            </div>
        </div>
    );
};

export default StudentSection;